export const GET_USERPROVISIONING_DATA = 'GET_USERPROVISIONING_DATA';
export const GET_USERPROVISIONING_DATA_SUCCESS = 'GET_USERPROVISIONING_DATA_SUCCESS';
export const TOGGLE_USERPROVISIONING = 'TOGGLE_USERPROVISIONING';
export const TOGGLE_USERPROVISIONING_SUCCESS = 'TOGGLE_USERPROVISIONING_SUCCESS';
export const REGENERATE_API_TOKEN = 'REGENERATE_API_TOKEN';
export const REGENERATE_API_TOKEN_SUCCESS = 'REGENERATE_API_TOKEN_SUCCESS';